import { create } from "zustand";
import { LISTE_ROLE } from "../Utils/constant";
import { find } from "../services/service";
export const useRoleStore = create((set) => ({
  loading: false,
  data: [],
  count: 1,
  getData: async (params) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const getItems = await find(`${LISTE_ROLE}?${params}`);
      setTimeout(() => {
        set({
          loading: false,
          data: getItems.data,
          count: getItems.data.totalPages,
        });
      }, 1000);
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
